import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MasterService } from 'src/app/core/services/master.service';
import { trackById } from 'src/app/core/utils/track-by';
import { environment } from 'src/app/environments/environment';
import { UserModel } from 'src/app/features/company-portal/modules/user-management/models/user-management.models';
import { UsersManagementService } from 'src/app/features/company-portal/modules/user-management/services/user-management.service';
import { CustomBreadcrumbService } from 'src/app/features/services/custom-breadcrumb.service';
import { onUserLogout } from 'src/main';
import { ROOT_COMPANY_ID } from '../../constants/constants';
import { RumSettings, Signout } from '../../models/shared.models';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css'],
  standalone: false,
})
export class NavmenuComponent {
  trackById = trackById;
  userDetails: any;
  userObj: UserModel = new UserModel();
  dataDagConfig: RumSettings = new RumSettings();
  dropdownOpen = false;
  activeCrumb: string = '';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private breadcrumbService: CustomBreadcrumbService,
    private masterService: MasterService,
    private cookieService: CookieService,
    private userManagementService: UsersManagementService,
  ) {}

  ngOnInit(): void {
    this.userDetails = this.masterService.getUserDetailFromStorage();
    this.getUserDetails();
    this.breadcrumbService.activeCrumbName$.subscribe((crumb) => {
      this.activeCrumb = crumb;
    });
  }

  getUserDetails(isUpdate: boolean = false) {
    let userId = this.userDetails.userid;
    this.userManagementService.getUserLiteById(userId, isUpdate).subscribe((res) => {
      this.userObj = res as UserModel;
    });
  }

  get isRoleArray(): boolean {
    return Array.isArray(this.userDetails?.role) && this.userDetails.role.length > 1;
  }

  nevigate(val: string) {
    switch (val) {
      case 'my profile':
        this.router.navigate(['/user-profile']);
        break;

      case 'user passcodes':
        this.router.navigate(['/user-passcodes']);
        break;

      case 'company':
        this.router.navigate(['/company-portal/settings/company-settings']);
        break;
    }
  }

  logout() {
    const sessionId = sessionStorage.getItem('sessionId');
    const userDetails = localStorage.getItem('user');
    this.masterService.userPermissions = [];
    this.masterService.rolesLoaded = false;
    let signOut = new Signout();
    signOut.sessionId = sessionId;
    if (userDetails) {
      const userDetailsObj = JSON.parse(userDetails);
      signOut.userId = userDetailsObj.userid;
    }
    const domain = environment.domainName;
    this.cookieService.set('logoutEvent', '1', 1 / 144, '/', domain);
    this.sharedService.getDatadogConfig(ROOT_COMPANY_ID, false).subscribe((res) => {
      if (res.enableRumForCompanyApp) {
        onUserLogout();
      }
    });
    this.sharedService.logout(signOut).subscribe({
      next: () => this.completeCleanup(),
      error: () => this.completeCleanup(),
    });
  }

  private completeCleanup() {
    this.sharedService.performFullSessionCleanup();
    this.router.navigate(['/shared/login']);
  }
}
